<div class="login-container">
  <form [formGroup]="loginForm">
    <div class="d-flex flex-column align-items-center">
      <img src="./assets/images/logo-bo-new-gen.png" alt="" height="50" width="170">
      <h1>ยินดีต้อนรับสู่ MERZ</h1>
    </div>
    <div class="not-match" *ngIf="loginfails == 1">
      <div>
        <span><img src="/assets/images/icon-valid.png" alt="" height="16" width="16"></span>
        E-mail หรือ รหัสผ่าน ไม่ถูกต้อง!
      </div>
    </div>
    <div class="not-match" *ngIf="loginfails == 2">
      <div>
        <span><img src="/assets/images/icon-valid.png" alt="" height="16" width="16"></span>
        ไม่สามารถเข้าใช้งานได้ กรุณาติดต่อผู้ดูแลระบบ
      </div>
    </div>
    <div class="form-group">
      <label for="email">E-mail</label>
      <input type="email" id="email" formControlName="email" placeholder="กรอก E-mail">
    </div>
    <div class="form-group">
      <label for="password">รหัสผ่าน</label>
      <div class="password-input-container">
        <input id="password" formControlName="password" [type]="isPasswordVisible ? 'text' : 'password'"
          placeholder="กรอกรหัสผ่าน" />
        <mat-icon class="password-toggle-icon" (click)="togglePasswordVisibility()">
          {{ isPasswordVisible ? 'visibility_off' : 'visibility' }}
        </mat-icon>
      </div>
      <a href="#" [routerLink]="'/auth/forgot-password'" class="forgot-password">ลืมรหัสผ่าน ?</a>
    </div>
    <button type="submit" class="btn btn-primary login-button" (click)="onSubmit()" [disabled]="loginForm.invalid">เข้าสู่ระบบ</button>
  </form>
</div>